import { ContentCard } from "@msuite/ui/content-card";
import { icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import { Panels } from "@msuite/ui/panels";
import { TableTypesForm } from "@/forms/table-types-form";
import { TicketTableTypeUsage } from "../ticket-table-type-usage";

export function OrganizationSettingsContacts() {
	/** Hooks */
	const { t } = useTranslation();

	/** Render */
	return (
		<Panels>
			<Panels.Panel flex={1}>
				<TicketTableTypeUsage
					table="contactTypes"
					title={t("contacts.contact_types")}
				/>
				<TicketTableTypeUsage
					table="contactMemberTypes"
					title={t("contacts.member_types")}
				/>
				<TicketTableTypeUsage
					table="contactMemberAuthorizationTypes"
					title={t("contacts.member_authorizations")}
				/>
			</Panels.Panel>
			<Panels.Panel flex={2}>
				<ContentCard
					title={t("contacts.contact_types")}
					icon={icon("Type")}
				>
					<TableTypesForm
						tableTypesTable="contactTypes"
						withIconSelect={false}
					/>
				</ContentCard>
				<ContentCard
					title={t("contacts.member_types")}
					icon={icon("User")}
				>
					<TableTypesForm
						tableTypesTable="contactMemberTypes"
						withIconSelect={false}
					/>
				</ContentCard>
				<ContentCard
					title={t("contacts.member_authorizations")}
					icon={icon("User")}
				>
					<TableTypesForm
						tableTypesTable="contactMemberAuthorizationTypes"
						withIconSelect={false}
					/>
				</ContentCard>
			</Panels.Panel>
		</Panels>
	);
}
